import {LinkTarget} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/link_target.types';
import {useHistory} from '@aboutyou/router';
import React from 'react';
import {useTrackNavigationBarOriginClick} from '../../hooks/useOriginClickTrackingFunction';
import {TouchOrMouseEventHandler} from '../TopCategoryNavigationView';

export const useNavigationItemEvents = (
  linkTarget: LinkTarget,
  onEnterNavigationItem: TouchOrMouseEventHandler,
  itemHasContent: boolean,
) => {
  const history = useHistory();
  const [isTouchDevice, setIsTouchDevice] = React.useState(false);
  const trackCategoryClick = useTrackNavigationBarOriginClick();

  const onItemClick: TouchOrMouseEventHandler = event => {
    event.preventDefault();
    event.stopPropagation();
    if (!isTouchDevice && linkTarget.url !== '') {
      trackCategoryClick();
      history.push(linkTarget.url);
    }
  };

  const handleTouchStart = () => {
    // We want to prevent triggering the history-update when
    // the item has content (flyout-content).
    // Without content we want to trigger the history-update
    // (e.g. Top 100 - no content - direct link).
    setIsTouchDevice(itemHasContent);
  };

  const handleMouseEnterNavItem: TouchOrMouseEventHandler = event => {
    if (!isTouchDevice) {
      onEnterNavigationItem(event);
    }
  };

  const [isDragging, setIsDragging] = React.useState(false);
  const handleTouchMove = () => {
    setIsDragging(true);
    setIsTouchDevice(true);
  };

  const handleTouchEnd: TouchOrMouseEventHandler = event => {
    // We are using touch end to trigger the callback because we want to
    // prevent the default behavior of the touch event. Meaning: onTouchStart
    // will be triggered when the user starts touching the screen, even though
    // he might be dragging. We don't want to trigger the callback in this case.
    if (!isDragging) {
      onEnterNavigationItem(event);
    } else {
      setIsDragging(false);
    }
  };

  return {
    onItemClick,
    handleTouchStart,
    handleMouseEnterNavItem,
    handleTouchMove,
    handleTouchEnd,
  };
};
